import React, { createContext, useContext, useState, useCallback } from "react";
import { EN_PHRASES } from "./i18nPhrases";

const STR = {
  tr: {
    appName: "JARVIS", appSub: "ModiHome Assistant",
    login: "Google ile Giriş Yap", loginTitle: "JARVIS — ModiHome Assistant",
    loginDesc: "İşlerinizi, projelerinizi ve müşterilerinizi takip eden kişisel iş asistanınız.",
    logout: "Çıkış",
    nav_today: "Bugün", nav_tasks: "Görevler", nav_projects: "Projeler", nav_clients: "Müşteriler",
    nav_emails: "E-postalar", nav_calendar: "Takvim", nav_proposals: "Teklifler", nav_files: "Dosyalar",
    nav_notifications: "Bildirimler", nav_usage: "Maliyet", nav_memory: "Hafıza", nav_settings: "Ayarlar",
    nav_site: "Şantiye", nav_finance: "Finans",
    aiConnected: "AI Bağlı", aiNotConnected: "AI Bağlı değil", demo: "Demo", notConnected: "Bağlı değil",
    ask: "Jarvis'e bir şey sorun...", send: "Gönder", startConv: "Konuşmayı başlat",
    endConv: "Konuşmayı bitir", micOff: "Mikrofonu kapat", micMute: "Sustur", clearChat: "Sohbeti temizle",
    attach: "Dosya ekle", wakeWord: "Uyandırma: 'Jarvis'", language: "Dil",
    state_idle: "Bekliyor", state_wake_listening: "Uyandırma açık", state_listening: "Dinliyor",
    state_thinking: "Düşünüyor", state_speaking: "Konuşuyor", state_executing: "Görev yürütüyor",
    state_mic_off: "Mikrofon kapalı", state_disconnected: "Bağlantı yok",
    add: "Ekle", save: "Kaydet", cancel: "İptal", delete: "Sil", edit: "Düzenle", close: "Kapat",
    today_top: "Günün en önemli işleri", today_overdue: "Geciken işler", today_due: "Bugün teslim",
    today_pending: "Bekleyen müşteri cevapları", today_projects: "Aktif projeler",
    startDay: "Jarvis, güne başlayalım", noData: "Veri yok", loading: "Yükleniyor...",
    menu: "Menü", talk: "Yazışma",
    set_sub: "Sohbet, ses, bağlantılar ve genel tercihler",
    tab_chat: "Yapay zekâ ve ses", tab_voice: "Mikrofon", tab_business: "Benim işim", tab_links: "Bağlantılar", tab_general: "Genel",
    card_chat: "Yapay zekâ ve ses", card_live: "Live konuşma", card_wakeword: "Uyandırma sözcüğü",
    card_mic: "Mikrofon", card_tts: "Yanıt sesi", card_business: "Benim işim · şirket, VAT, teklif ve tercihler",
    card_gmail: "Gmail posta kutusu", card_calendar: "Google Takvim", card_mail_accounts: "Posta hesapları · iş / kişisel",
    card_feeds: "Haber, araştırma ve müzik", card_motion: "Hareket", card_language: "Dil",
    tts_note: "Yazışmada otomatik sesli okuma kapalıdır; bu ses, sesli konuşma akışında kullanılan yedek sestir.",
    voice_pick: "Ses seçimi",
    motion_reduced: "Azaltıldı", motion_smooth: "Akıcı", motion_enable: "Animasyonları aç", motion_reduce: "Animasyonları azalt",
    map_search_ph: "Adres veya yer adı ara…", map_search_btn: "Ara",
    map_consent: "Aramaya basınca sorgu OpenStreetMap · Nominatim'e gönderilir: {q}",
    map_notfound: "'{q}' için konum bulunamadı.", map_fail: "Konum araması başarısız.",
    news_notfound: "Haber bulunamadı", news_notfound_today: "Haber bulunamadı (bugün için tarihi doğrulanmış haber yok)",
  },
  en: {
    appName: "JARVIS", appSub: "ModiHome Assistant",
    login: "Sign in with Google", loginTitle: "JARVIS — ModiHome Assistant",
    loginDesc: "Your personal business assistant tracking jobs, projects and clients.",
    logout: "Logout",
    nav_today: "Today", nav_tasks: "Tasks", nav_projects: "Projects", nav_clients: "Clients",
    nav_emails: "Emails", nav_calendar: "Calendar", nav_proposals: "Proposals", nav_files: "Files",
    nav_notifications: "Alerts", nav_usage: "Cost", nav_memory: "Memory", nav_settings: "Settings",
    nav_site: "Site Mode", nav_finance: "Finance",
    aiConnected: "AI Connected", aiNotConnected: "AI Not connected", demo: "Demo", notConnected: "Not connected",
    ask: "Ask Jarvis anything...", send: "Send", startConv: "Start conversation",
    endConv: "End conversation", micOff: "Turn mic off", micMute: "Mute", clearChat: "Clear chat",
    attach: "Attach", wakeWord: "Wake word: 'Jarvis'", language: "Language",
    state_idle: "Standby", state_wake_listening: "Wake active", state_listening: "Listening",
    state_thinking: "Thinking", state_speaking: "Speaking", state_executing: "Executing",
    state_mic_off: "Mic off", state_disconnected: "Offline",
    add: "Add", save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", close: "Close",
    today_top: "Top jobs today", today_overdue: "Overdue", today_due: "Due today",
    today_pending: "Pending client replies", today_projects: "Active projects",
    startDay: "Jarvis, start my day", noData: "No data", loading: "Loading...",
    menu: "Menu", talk: "Chat",
    set_sub: "Chat, voice, connections and general preferences",
    tab_chat: "AI and voice", tab_voice: "Microphone", tab_business: "My business", tab_links: "Connections", tab_general: "General",
    card_chat: "AI and voice", card_live: "Live conversation", card_wakeword: "Wake word",
    card_mic: "Microphone", card_tts: "Reply voice", card_business: "My business · company, VAT, proposals and preferences",
    card_gmail: "Gmail mailbox", card_calendar: "Google Calendar", card_mail_accounts: "Mail accounts · work / personal",
    card_feeds: "News, research and music", card_motion: "Motion", card_language: "Language",
    tts_note: "Auto read-aloud is off in chat; this is the fallback voice used in the spoken conversation flow.",
    voice_pick: "Voice selection",
    motion_reduced: "Reduced", motion_smooth: "Smooth", motion_enable: "Enable animations", motion_reduce: "Reduce animations",
    map_search_ph: "Search address or place…", map_search_btn: "Search",
    map_consent: "On search, the query is sent to OpenStreetMap · Nominatim: {q}",
    map_notfound: "No location found for '{q}'.", map_fail: "Location search failed.",
    news_notfound: "No news found", news_notfound_today: "No news found (no date-verified items for today)",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("jarvis_lang") || "tr");
  const setLang = useCallback((l) => {
    localStorage.setItem("jarvis_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((k, vars) => {
    let s = (STR[lang] && STR[lang][k]) || STR.tr[k] || k;
    if (vars) for (const vk of Object.keys(vars)) s = s.split("{" + vk + "}").join(vars[vk]);
    return s;
  }, [lang]);
  const tx = useCallback((s, vars) => {
    let out = lang === "en" ? (EN_PHRASES[s] || s) : s;
    if (vars) for (const vk of Object.keys(vars)) out = out.split("{" + vk + "}").join(vars[vk]);
    return out;
  }, [lang]);
  return <I18nContext.Provider value={{ lang, setLang, t, tx }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
